/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ProductBulkAction = typeof ProductBulkAction[keyof typeof ProductBulkAction];


export const ProductBulkAction = {
  reconcile_asset_downloads: 'reconcile_asset_downloads',
  reconcile_transcoding: 'reconcile_transcoding',
  reconcile_asset_publish: 'reconcile_asset_publish',
  requeue_import: 'requeue_import',
} as const;
